export default __webpack_public_path__ + "static/media/location-2.78008b28.png";